<template>
    <div>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name:'inter',
    data(){
        return{

        }
    }
}
</script> 
<style scoped lang="scss">
    
</style>